import { strings } from "../../../localization";
import {
	Box,
	BoxedRow,
	ButtonLayout,
	ButtonLink,
	ButtonPrimary,
	Grid,
	GridItem,
	IconCancelLight,
	IconQuestionRegular,
	Text2,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, { useCallback, useEffect, useState } from "react";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import { useNavigateCustom, useOpenFGTSApp } from "../../../hooks";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { useLocalObservable } from "mobx-react-lite";
import { PostBalanceInquiryRequestFetchStore } from "../../../stores";
import { useAnalytics } from "../../../hooks/useAnalytics";
import { getFFSecondQiTechAccount } from "../../../services/SystemConfiguration";

const { listSecondAccount, infoSecondAccount, descriptionSecondAccount } = strings.pages.authorizationInquiryBalance;

const errorInfo = strings.components.connectionFeedback.errors;
export const UnauthorizedInstitution: React.FC = () => {
	const navigation = useNavigateCustom();
	const [isSecondAccount, setIsSecondAccount] = useState(false);

	const { addAnalyticEvent, updatePageView } = useAnalytics();

	const { isDesktopOrBigger } = useScreenSize();

	const handleAddAnalyticEvent = (description: string): void => {
		addAnalyticEvent({
			component: "body",
			action: "click.button",
			description,
			step: "fgts:conexao-nao-autorizada",
			value: "",
		}, { applySanitize: true });
	};

	const handleHowToAuthorize = React.useCallback(() => {
		handleAddAnalyticEvent(errorInfo.unauthorizedInstitution.buttons.boxedRowTitle);
		navigation("/how-to-authorize");
	}, []);

	const { authenticationStore } = useGlobalStore();
	const store = useLocalObservable(
		() => new PostBalanceInquiryRequestFetchStore(
			authenticationStore,
			() => navigation("/connect-fgts-balance"),
		),
	);

	const handleOnPressButton = async (): Promise<void> => {
		handleAddAnalyticEvent(errorInfo.unauthorizedInstitution.buttons.primaryButton);
		store.fetchShelf.fetch();
	};

	const handleOnPressLink = async (): Promise<void> => {
		handleAddAnalyticEvent(errorInfo.unauthorizedInstitution.buttons.linkButton);
		useOpenFGTSApp();
	};

	// Busca valor da feature flag secondQiTechAccount
	const fetchFeatureFlag = useCallback(async (): Promise<void> => {
		const ffIsSecondAccount = await getFFSecondQiTechAccount();
		setIsSecondAccount(ffIsSecondAccount);
	}, []);

	useEffect(() => {
		fetchFeatureFlag();
	}, []);


	useEffect(() => {
		addAnalyticEvent({
			component: "body",
			action: "view-error",
			description: "conexao-nao-autorizada",
			step: "fgts:conexao-nao-autorizada",
			value: "",
			event: "non_interaction",
		}, { applySanitize: true });

		updatePageView({
			name: "Vivo Money FGTS Conexão Não Autorizada",
			pagePath: "/fgts/conexao-nao-autorizada",
		});
	}, []);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconCancelLight size={64} color={skinVars.colors.controlError} />}
						title={errorInfo.unauthorizedInstitution.title}
						description={!isSecondAccount ?
							<>
								<Text3 light color={skinVars.colors.neutralMediumInverse}>
									{errorInfo.unauthorizedInstitution.firstText}
									<Text3 medium color={skinVars.colors.neutralMediumInverse}>
										{errorInfo.unauthorizedInstitution.boldText(isSecondAccount)}
									</Text3>
									{errorInfo.unauthorizedInstitution.lastText}
								</Text3>
							</>
							:
							<>
								<Text3 light color={skinVars.colors.neutralMediumInverse}>
									{descriptionSecondAccount[0]}
									<Text3 medium color={skinVars.colors.neutralMediumInverse}>
										{descriptionSecondAccount[1]}
									</Text3>
									{descriptionSecondAccount[2]}

									<>
										<br />
										<br />
										<ul style={{ display: "flex", paddingLeft: 18, justifyContent: "center", alignItems: "flex-start", flexDirection: "column"}}>
											<li style={{ listStyleType: "circle" }}>
												<Text3 medium color={skinVars.colors.neutralMediumInverse}>
													{listSecondAccount[0]}
												</Text3>
											</li>

											<li style={{ listStyleType: "circle"}}>
												<Text3 medium color={skinVars.colors.neutralMediumInverse}>
													{listSecondAccount[1]}
												</Text3>
											</li>
										</ul>
										<br />
										{infoSecondAccount}
									</>

								</Text3>
							</>
						}
						slot={
							<BoxedRow
								onPress={handleHowToAuthorize}
								asset={<IconQuestionRegular color={skinVars.colors.brand} />}
								title={errorInfo.unauthorizedInstitution.buttons.boxedRowTitle}
							/>
						}
					>
						<Box paddingTop={isDesktopOrBigger ? 40 : 0}>
							<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
								<ButtonPrimary
									onPress={handleOnPressButton}
									showSpinner={store.fetchShelf.loader.isLoading}
									disabled={store.fetchShelf.loader.isLoading}
									style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
								>
									<Text3 medium color={skinVars.colors.textButtonPrimary}>
										{errorInfo.unauthorizedInstitution.buttons.primaryButton}
									</Text3>
								</ButtonPrimary>

								<ButtonLink
									onPress={handleOnPressLink}
									disabled={store.fetchShelf.loader.isLoading}
								>
									<Text2 medium color={skinVars.colors.textLink}>
										{errorInfo.unauthorizedInstitution.buttons.linkButton}
									</Text2>
								</ButtonLink>
							</ButtonLayout>
						</Box>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
};

export default UnauthorizedInstitution;
